import React, { useEffect, useState } from 'react';
import { MDBCard, MDBCardHeader, MDBListGroup, MDBListGroupItem } from 'mdb-react-ui-kit';
import "./InfoPopup.css";
import UserControlService from '../../services/user-control-service';
import { nanoid } from 'nanoid';

export interface InfoPopupProps {
    title?: string;
    content?: string;
    color?: string;
    duration?: number;
}

export default function InfoPopup() {
    const [body, setBody] = useState<any>(null);

    useEffect(() => {
        UserControlService.onShowInfoPopup((p: InfoPopupProps) => {
            setBody(null);
            setBody(<InfoPopupBody key={nanoid()} {...p}/>);
        })
    }, [])

    return body;
}

function InfoPopupBody(props : InfoPopupProps) {

    const [isHidden, setHidden] = useState(false);

    useEffect(() => {
        // Only set up auto-hide if:
        // 1. There's a duration specified
        // 2. The color is NOT "danger" (error/warning messages)
        if (!props.duration || props.color === "danger") { 
            return; 
        }
        
        const timeout = setTimeout(() => { 
            setHidden(true) 
        }, props.duration);
        
        return () => {
            clearTimeout(timeout);
        }
    }, [props.duration, props.color])  // Added proper dependencies

    // Don't render anything if hidden
    if (isHidden) return null;

    return <MDBCard className={'info-popup text-' + (props.color || "dark")} style={isHidden ? { animation: "slide-out-right 0.25s forwards ease-in-out" } : {}}>
        <MDBCardHeader background={props.color || "dark"} className="info-popup-header">
            <span className='d-flex justify-content-between'>
                <span className='text-light fw-bold'>{props.title}</span>
                <i className="fas fa-times accept-modal-button text-light" onClick={() => { setHidden(true) }} />
            </span>
        </MDBCardHeader>
        <MDBListGroup flush>
            {/* Only show timer for auto-hiding messages */}
            {props.color !== "danger" && props.duration && (
                <span className={'info-popup-timer bg-' + (props.color || "dark")}
                    style={{ animation: `grow ${props.duration}ms forwards linear` }} />
            )}
            <MDBListGroupItem>
                <small>{props.content}</small>
            </MDBListGroupItem>
        </MDBListGroup>
    </MDBCard>
}